import { isMobile } from '@/lib/device'
import i18n from '@/lib/language'
// const devicePath = !isMobile ? 'pc' : 'mobile'
import xiaoman from './project-config-xiaoman'

export default [
  {
    path: 'config/index',
    name: 'configIndex',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/Index')
  },
  {
    path: 'config/collect',
    name: 'configCollect',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/Collect')
  },
  {
    path: 'config/referrer',
    name: 'configreferrer',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/Referrer')
  },
  {
    path: 'config/relationlist',
    name: 'configRelationList',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/RelationList')
  },
  {
    path: 'config/relationinfo',
    name: 'configRelationInfo',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/RelationInfo')
  },
  {
    path: 'quit',
    name: 'quit',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/quit/Quit.vue')
  },
  {
    path: 'config/ocpc/list',
    name: 'ocpc',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/ocpc/OcpcList.vue'),
    meta: { title: 'oCPC' }
  },
  {
    path: 'config/clue',
    name: 'configClue',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/Clue.vue'),
    meta: { title: '线索配置' }
  },
  {
    path: 'config/ocpc/setlist',
    name: 'setList',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/ocpc/OcpcSetList.vue'),
    meta: { title: 'oCPC' }
  },
  {
    path: 'config/ocpc/set',
    name: 'setOcpc',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/ocpc/OcpcSetting.vue'),
    meta: { title: 'oCPC' }
  },
  {
    path: 'config/visit',
    name: 'configVisit',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/Visit')
  },
  {
    path: 'config/notice',
    name: 'configNotice',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/Notice')
  },
  {
    path: 'config/sensitive',
    name: 'configSensitive',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/sensitive/Index'),
    meta: { title: i18n.t('message["645"]') }
  },
  {
    path: 'config/smart',
    name: 'configSmart',
    component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/smart/Index'),
    meta: { title: i18n.t('message["1246"]') }
  },
  {
    path: 'config/rule',
    name: 'configRule',
    component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/InfoSetMethod'),
    meta: { title: i18n.t('message["1362"]') }
  },
  {
    path: 'config/import',
    component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/import/Index'),
    meta: { title: i18n.t('message["710"]') },
    children: [{
      path: 'list',
      name: 'configImportList',
      component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/import/List')
    },
    {
      path: 'create',
      component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/import/create/Create'),
      children: [{
        path: '1',
        name: 'configImportFirst',
        component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/import/create/First')
      }, {
        path: '2',
        name: 'configImportSecond',
        component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/import/create/Second')
      },
      {
        path: '3',
        name: 'configImportFinish',
        component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/import/create/Finish')
      }]
    }]
  },
  {
    path: 'config/listset',
    name: 'configListSet',
    component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/ListSet'),
    meta: { title: i18n.t('message["609"]') }
  },
  {
    path: 'config/repeat',
    name: 'configRepeat',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/repeat/Index'),
    meta: { title: i18n.t('message["1357"]') }
  },
  {
    path: 'config/repeat/white',
    name: 'RepeatWhite',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/repeat/RepeatWhite'),
    meta: { title: i18n.t('message["1357"]') }
  },
  {
    path: 'config/service',
    name: 'configService',
    component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/service/Index'),
    children: [
      {
        path: 'index',
        name: 'ServiceIndex',
        component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/service/Card')
      },
      {
        path: 'buy',
        name: 'ServiceBuy',
        component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/service/ToBuy')
      },
      {
        path: 'super',
        name: 'ServiceSuper',
        component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/service/Super')
      },
      {
        path: 'expansion',
        name: 'ServiceExpasion',
        component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/service/Expansion')
      },
      {
        path: 'sms',
        name: 'ServiceSms',
        component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/service/Sms'),
        meta: { title: i18n.t('message["252"]') }
      },
      {
        path: 'email',
        name: 'ServiceEmail',
        component: () => import(/* webpackChunkName: "pc-base" */ '@/pc/config/service/Email'),
        meta: { title: i18n.t('message["1502"]') }
      }
    ]
  },
  {
    path: 'config/logo',
    name: 'configLogo',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/config/logo/Index`)
        : import(/* webpackChunkName: "pc-base" */ `@/pc/config/logo/Index`),
    meta: { title: i18n.t('message["986"]') + 'logo' }
  },
  {
    path: 'config/webhook',
    name: 'configWebhook',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/WebHook'),
    redirect: () => {
      return {
        name: 'configWebhookList'
      }
    },
    children: [
      {
        path: 'list',
        name: 'configWebhookList',
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
            : import(/* webpackChunkName: "pc-base" */ '@/pc/config/webhook/List'),
        meta: { title: 'Webhook' }
      },
      {
        path: 'sendrecord/:hookid',
        name: 'configSendRecord',
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
            : import(/* webpackChunkName: "pc-base" */ '@/pc/config/webhook/SendRecord'),
        meta: { title: '推送记录' }
      },
      {
        path: 'addwebhook',
        name: 'configAddWebhook',
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
            : import(/* webpackChunkName: "pc-base" */ '@/pc/config/webhook/AddWebhook'),
        meta: { title: i18n.t('message["1190"]') + 'Webhook' }
      }
    ]
  },
  {
    path: 'config/withdraw',
    name: 'configWithdraw',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/automaticWithdraw/Index'),
    meta: {
      title: '自动收回',
      menuKey: 'project-config'
    }
  },
  ...xiaoman,
  {
    path: 'config/tv',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/tv/Index.vue'),
    redirect: () => {
      return {
        name: 'configTvList'
      }
    },
    children: [
      {
        path: 'list',
        name: 'configTvList',
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
            : import(/* webpackChunkName: "pc-base" */ '@/pc/config/tv/List'),
        meta: { title: '电视大屏' }
      },
      {
        path: 'group',
        name: 'configTvGroupList',
        component: () =>
          isMobile
            ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
            : import(/* webpackChunkName: "pc-base" */ '@/pc/config/tv/GroupList'),
        meta: { title: '电视大屏' }
      }
    ]
  },
  {
    path: 'config/tv/add',
    name: 'configAddTv',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/tv/TvDetail'),
    meta: '电视大屏'
  },
  {
    path: 'config/tv/detail/:id',
    name: 'configTvDetail',
    props: true,
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/tv/TvDetail'),
    meta: '电视大屏'
  },
  {
    path: 'config/relateproject',
    name: 'RelatedProject',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/RelatedProject')
  },
  {
    path: 'config/listview',
    name: 'configListView',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`)
        : import(/* webpackChunkName: "pc-base" */ '@/pc/config/listview/Index.vue')
  }
]
